module.exports = __webpack_public_path__ + "static/cawthra-guia-fousekis-helen-9a5cabb8e8fa752d652b69c323275717.jpg";